import type { CoinMode } from '@ui/hooks/useCoinMode';
import type { GardenType } from '@ui/utils/garden';
import { gardenTypes, getGardenName } from '@ui/utils/garden';

import type { HarvestElement } from './useHarvestAllDrawer';

export const getHarvestElementName = (
  type: HarvestElement,
  coinMode?: CoinMode,
) => {
  const usedCoinMode = coinMode ?? 'cro';
  const isGarden = isGardenType(type);
  return isGarden
    ? getGardenName(usedCoinMode, type)
    : type.charAt(0) + type.slice(1).toLowerCase();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isGardenType(type: any): type is GardenType {
  return gardenTypes.includes(type);
}
